var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',[_c('div',{staticClass:"version-info"},[_vm._v(_vm._s(_vm.config.version))]),_c('div',{staticClass:"copyright text-center"},[_vm._v("© SIA Zaļais Punkts")])])])}
var staticRenderFns = []

export { render, staticRenderFns }